var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskManagePortfolioBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1,135V33h35.25l18,74.4,18-74.4H125.6V135H104.9V56.1h-2.25L82.7,130.5H62L42.052,56.1H39.8V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.485,135,151.55,63.6h27.51L195.125,135h-14.49L177.8,122.085H152.81L149.975,135Zm27.3-59.43-7.245,33.915h19.53L167.825,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.579,135V63.6h24.464l17.221,58.8h1.049V63.6H259.8V135H235.969l-17.85-58.8h-1.051V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.258,135l16.065-71.4h27.51L326.9,135h-14.49l-2.835-12.915h-24.99L281.748,135Zm27.3-59.43-7.245,33.915h19.53L299.6,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.018,109.38V96.78h20.79v37.066a160.533,160.533,0,0,1-24.36,2.414q-16.695,0-22.943-8.925t-6.247-28.35q0-19.424,6.51-28.035t22.155-8.61a111,111,0,0,1,21.105,2.2l3.78.735-.42,11.236a199.226,199.226,0,0,0-20.633-1.366q-8.033,0-11.287,1.89t-4.778,6.982q-1.522,5.1-1.523,17.431t3.046,17.273q3.043,4.936,12.6,4.934l8.716-.42V109.38Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.357,135V63.6h46.2V76.2h-31.71V92.9h25.41v12.389h-25.41V122.4h31.71V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.253,105.3h-16.8V135h-20.7V33h37.5q36.3,0,36.3,35.4,0,17.853-9.225,27.375T522.253,105.3Zm-16.8-17.7H522.1q15.447,0,15.449-19.2,0-9.449-3.75-13.575T522.1,50.7H505.453Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.174,127.388q-6.669,8.874-22.943,8.872t-22.942-8.872q-6.669-8.871-6.667-27.773t6.667-28.088q6.666-9.186,22.942-9.187t22.943,9.187q6.668,9.191,6.667,28.088T616.174,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T604.781,80.82q-3.148-5.88-11.55-5.88t-11.549,5.88q-3.15,5.882-3.151,18.848T581.629,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.621,111.061V135h-14.49V63.6h27.72q25.2,0,25.2,23.519,0,13.966-10.5,20.58L685.736,135H669.881l-8.295-23.939Zm21.105-15.54a12.885,12.885,0,0,0,2.52-8.3,11.96,11.96,0,0,0-2.678-8.191q-2.678-3.043-7.717-3.045h-13.23V98.67h13.44Q666.2,98.67,668.726,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.726,76.41V63.6h52.5V76.41h-18.9V135h-14.49V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.259,135V63.6h45.57V76.2h-31.08v21h25.41v12.6h-25.41V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.315,127.388q-6.669,8.874-22.942,8.872t-22.943-8.872q-6.669-8.871-6.667-27.773t6.667-28.088q6.668-9.186,22.943-9.187t22.942,9.187q6.667,9.191,6.667,28.088T852.315,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T840.922,80.82q-3.149-5.88-11.549-5.88t-11.55,5.88q-3.15,5.882-3.151,18.848T817.77,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.907,135H869.272V63.6h14.49V122.19h26.145Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.73,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.062,127.388q-6.668,8.874-22.942,8.872t-22.942-8.872q-6.671-8.871-6.668-27.773t6.668-28.088q6.666-9.186,22.942-9.187t22.942,9.187q6.667,9.191,6.668,28.088T994.062,127.388Zm-34.544-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T982.67,80.82q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.15,5.882-3.15,18.848T959.518,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskManagePortfolioBanner);
export default __webpack_public_path__ + "static/media/BreachRisk_Manage_Portfolio_Banner.b98f19cfbd4c2248bfd5d3d859c44419.svg";
export { ForwardRef as ReactComponent };